"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUnusedObjectKeyCustomCheck = exports.getUnusedObjectKey = exports.generateNewId = exports.parseObjCustomState = void 0;
const non_secure_1 = require("nanoid/non-secure");
function parseObjCustomState(obj) {
    const state = obj?.customState;
    if (state) {
        try {
            return JSON.parse(state);
        }
        catch (e) {
            console.log("error getting custom state");
        }
    }
    return null;
}
exports.parseObjCustomState = parseObjCustomState;
const generateNewId = (currId, idList) => {
    const digitsAtEndMatch = currId.match(/\d+$/);
    let newId;
    if (digitsAtEndMatch && digitsAtEndMatch[0]) {
        const indexOfDigits = currId.indexOf(digitsAtEndMatch[0]);
        newId = currId.substring(0, indexOfDigits) + (parseInt(digitsAtEndMatch[0], 10) + 1);
    }
    else {
        newId = currId + "-2";
    }
    if (idList.includes(newId)) {
        return (0, exports.generateNewId)(newId, idList);
    }
    else {
        return newId;
    }
};
exports.generateNewId = generateNewId;
const getUnusedObjectKey = (takenKeys) => (0, exports.getUnusedObjectKeyCustomCheck)((k) => k in takenKeys);
exports.getUnusedObjectKey = getUnusedObjectKey;
const getUnusedObjectKeyCustomCheck = (isKeyTaken) => {
    let count = 0;
    let k = "";
    do {
        if (count++ > 10000)
            throw new Error("can't find a key after 10k attempts, throwing to avoid an infinite loop");
        k = (0, non_secure_1.nanoid)(4);
    } while (isKeyTaken(k));
    return k;
};
exports.getUnusedObjectKeyCustomCheck = getUnusedObjectKeyCustomCheck;
//# sourceMappingURL=objectUtils.js.map